import { mergeHomePreferences } from '../model/homePreferences';

export const homePreferencesKey = id => ['home','preferences',id || null];
export async function readHomeProfile(client, id) {
  if (!id) throw new Error('Sign in to load your Home settings.');
  const {data,error} = await client.from('user_profiles')
    .select('id,preferences,my_designer_name,display_name').eq('id',id).single();
  if (error) throw error;
  if (!data || data.id !== id) throw new Error('Your Home settings could not be loaded.');
  return data;
}
async function checkAccount(client, actorId) {
  const {data,error} = await client.auth.getUser();
  if (error) throw error;
  if (!actorId || data?.user?.id !== actorId) throw new Error('Your account changed. Reopen Home settings before saving.');
}
// Conditional JSON equality closes the read/merge/write race with other preference writers.
// Every conflict re-reads the whole JSON so unrelated preferences survive the retry.
export async function saveHomePreferences(client, id, patch, actorId = id) {
  for (let attempt=0; attempt<3; attempt+=1) {
    await checkAccount(client,actorId);
    const profile = await readHomeProfile(client,id);
    const preferences = mergeHomePreferences(profile.preferences,patch);
    await checkAccount(client,actorId);
    let write = client.from('user_profiles').update({preferences}).eq('id',id);
    write = profile.preferences == null ? write.is('preferences',null) : write.eq('preferences',JSON.stringify(profile.preferences));
    const {data,error} = await write.select('id,preferences,my_designer_name,display_name').maybeSingle();
    if (error) throw error;
    if (data) return data;
  }
  throw new Error('Home settings changed elsewhere. Please retry your save.');
}
export function createHomeSaveQueue() {
  const queues = new Map();
  return (id, operation) => {
    const previous = queues.get(id) || Promise.resolve();
    const result = previous.catch(() => {}).then(operation);
    queues.set(id,result);
    const release = () => { if (queues.get(id) === result) queues.delete(id); };
    result.then(release,release);
    return result;
  };
}
export const enqueueHomeSave = createHomeSaveQueue();
